import {FormConfig} from '../../form/form.config';
import {FormModelText} from '../../form/form.model.text';
import {FormModel} from '../../form/form.model.abstract';
import {Validators} from '@angular/forms';
import {FormModelRadio} from '../../form/form.model.radio';
import {ValidationService} from '../../services/validation.service';
import {FormModelNumber} from '../../form/form.model.number';
import {FormModelDates} from '../../form/form.model.dates';
import {StancheckForm} from "../stancheck.form";
import {FormModelPercent} from "../../form/form.model.percent";

/**
 * Configuration for the input of the first chapter in the stromcheck advisor.
 * @inheritDoc
 */
export class GebaeudeForm extends StancheckForm {

  /**
   * @inheritDoc
   *
   * ATTENTION: Some of these values/fields are also used in StromcheckController.php. Check changes also there.
   *
   * @protected
   */
  protected fields: FormModel[] = [
    // Basisinformationen
    new FormModelRadio(
      'type_wfl', ['1-2familienhaus', 'mehrfamilienhaus'],
      [Validators.required], null, null, false
    ),
    new FormModelNumber(
      'a_wfl', [Validators.required, Validators.min(10), Validators.max(400)],
      null, null, false
    ),
    new FormModelNumber(
      'n_pers', [Validators.required, Validators.min(1), Validators.max(10)],
      null, 1, false
    ),

    // Verbrauchsdaten
    new FormModelDates(
      'date_grid', ['date_grid_start', 'date_grid_end'],
      [Validators.required, ValidationService.dateFormat], null,
      [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], false
    ),
    new FormModelText('wel_grid', [Validators.required, ValidationService.greaterZero], 'kwh', null, false, 'number'),

    // Waermepumpe
    new FormModelRadio('exist_hp', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('include_wel_hh_hp', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelRadio('exist_wel_hp', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelText('wel_hp', [Validators.required], 'kwh', null, false, 'number')),
    (new FormModelRadio('exist_wel_hp_date', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelDates(
      'date_hp', ['date_hp_start', 'date_hp_end'],
      [Validators.required, ValidationService.dateFormat], null,
      [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], false
    )),

    // Stromdirektheizung
    (new FormModelRadio('exist_eheat', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelRadio('include_wel_hh_eheat', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelRadio('exist_wel_eheat', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelText('wel_eheat', [], 'kwh', 0, false, 'number')),
    (new FormModelRadio('exist_wel_eheat_date', ['ja', 'nein'], [Validators.required], null, null, false)),
    (new FormModelDates(
      'date_ehheat', ['date_eheat_start', 'date_eheat_end'],
      [Validators.required, ValidationService.dateFormat], null,
      [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], false
    )),

    // Warmwasser
    new FormModelRadio('type_dhw', [], [Validators.required], null, null, false),

    // Photovoltaik
    new FormModelRadio('exist_pv', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_wel_pv', ['ja', 'nein'], [Validators.required], null, null, false),

    // mit PV Eigenverbrauch
    new FormModelText('wel_pv', [Validators.required, ValidationService.greaterZero], 'kwh', null, false, 'number'),
    new FormModelRadio('exist_wel_pv_date', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelDates(
      'date_pv', ['date_pv_start', 'date_pv_end'],
      [Validators.required, ValidationService.dateFormat], null,
      [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], false
    ),

    // ohne PV Eigenverbrauch
    new FormModelText('p_pv_peak', [Validators.required, ValidationService.greaterZero], 'kwp', null, false, 'number'),
    new FormModelRadio('exist_battery_pv', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelText('wel_battery_pv', [Validators.required, ValidationService.greaterZero], 'kwh', null, true, 'number'),

    // Elektromobilität
    new FormModelRadio('exist_ev', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('wel_ev_grid', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_wel_ev', ['ja', 'nein'], [Validators.required], null, null, false),

    // mit EV Ladeenergie
    new FormModelText('wel_ev', [Validators.required, ValidationService.greaterZero], 'kwh', null, false, 'number'),
    new FormModelRadio('exist_wel_ev_date', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelDates(
      'date_ev', ['date_ev_start', 'date_ev_end'],
      [Validators.required, ValidationService.dateFormat], null,
      [FormConfig.getFirstDayOfLastYear(), FormConfig.getLastDayOfLastYear()], false
    ),

    // ohne EV Ladeenergie
    (new FormModelText('distance_ev', [Validators.required, ValidationService.greaterZero], 'kwh', null, false, 'number')),
    (new FormModelPercent('f_ev_percentage', ['f_ev_load', 'f_ev_charging_station'], [Validators.required], [50, 50], false)),

    // Technische Haushaltsausstattung - Waschen und Spülen
    new FormModelRadio('exist_ws_gs', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_ws_wm', ['ja', 'nein'], [Validators.required], null, null, false),
    new FormModelRadio('exist_ws_tr', ['ja', 'nein'], [Validators.required], null, null, false),
    (new FormModelRadio('ws_tr_winter_only', ['ja', 'nein'], [Validators.required], null, null, false)).setInactive(),

    // Geräteinformationen
    (new FormModelRadio('size_gs', ['bis_60', 'ab_60'], [Validators.required])).setInactive(),
    (new FormModelRadio('age_gs', ['bis_5', '5_bis_15', 'ab_15'], [Validators.required])).setInactive(),
    (new FormModelNumber('t_gs', [Validators.required, ValidationService.greaterZero])).setInactive(),

    (new FormModelRadio('size_wm', ['bis_6', 'ab_6'], [Validators.required])).setInactive(),
    (new FormModelRadio('age_wm', ['bis_5', '5_bis_15', 'ab_15'], [Validators.required])).setInactive(),
    (new FormModelNumber('t_wm', [Validators.required, ValidationService.greaterZero])).setInactive(),

    (new FormModelRadio('size_tr', ['bis_60', 'ab_60'], [Validators.required])).setInactive(),
    (new FormModelRadio('age_tr', ['bis_5', '5_bis_15', 'ab_15'], [Validators.required])).setInactive(),
    (new FormModelNumber('t_tr', [Validators.required, ValidationService.greaterZero])).setInactive(),
  ];

  /**
   * List of formfields where changes of the value, change other fields.
   */
  fieldsForFormChanges: string[] = [
    'exist_hp',
    'exist_wel_hp',
    'exist_wel_hp_date',
    'exist_eheat',
    'include_wel_hh_eheat',
    'exist_wel_eheat',
    'exist_wel_eheat_date',
    'exist_pv',
    'exist_wel_pv',
    'exist_wel_pv_date',
    'exist_battery_pv',
    'exist_ev',
    'wel_ev_grid',
    'exist_wel_ev',
    'exist_wel_ev_date',
  ];

  /**
   * @inheritDoc
   * @protected
   */
  protected groups = {
    'basisdaten/1': ['type_wfl'],
    'basisdaten/2': ['a_wfl'],
    'basisdaten/3': ['n_pers'],
    'basisdaten/4': ['date_grid', 'wel_grid'],
    'heizung/1': ['exist_hp'],
    'heizung/2': ['include_wel_hh_hp'],
    'heizung/3': ['exist_wel_hp', 'wel_hp', 'exist_wel_hp_date', 'date_hp'],
    'heizung/4': ['exist_eheat'],
    'heizung/5': ['include_wel_hh_eheat'],
    'heizung/6': ['exist_wel_eheat', 'wel_eheat', 'exist_wel_eheat_date', 'date_ehheat'],
    'heizung/7': ['type_dhw'],
    'photovoltaik/1': ['exist_pv'],
    'photovoltaik/2': ['exist_wel_pv'],
    'photovoltaik/3': ['wel_pv', 'exist_wel_pv_date', 'date_pv'],
    'photovoltaik/4': ['p_pv_peak'],
    'photovoltaik/5': ['exist_battery_pv', 'wel_battery_pv'],
    'elektromobilitaet/1': ['exist_ev', 'wel_ev_grid'],
    'elektromobilitaet/2': ['exist_wel_ev'],
    'elektromobilitaet/3': ['wel_ev', 'exist_wel_ev_date', 'date_ev'],
    'elektromobilitaet/4': ['distance_ev', 'f_ev_percentage'],
  };

  /**
   * Any time a field is updated, this method is called.
   * @param values
   */
  updateFields(values: { [key: string]: any }): any {
    values = this.updateFieldsHeatPump(values);
    values = this.updateFieldsHeating(values);
    values = this.updateFieldsWarmwater(values);
    values = this.updateFieldsPhotovoltaic(values);
    values = this.updateFieldsElectricVehicle(values);
    return values;
  }

  private updateFieldsHeatPump(values: { [key: string]: any }): { [key: string]: any } {
    if (values.hasOwnProperty('type_wfl')) {
      if (values.type_wfl === '1-2familienhaus') {
        this.activateField('exist_hp');
      } else {
        this.deactivateField('exist_hp');
        values.exist_hp = null;
      }
    }
    if (values.hasOwnProperty('exist_hp')) {
      if (values.exist_hp === 'ja') {
        this.activateField('include_wel_hh_hp');
        this.activateField('exist_wel_hp');
      } else {
        this.deactivateField('include_wel_hh_hp');
        values.include_wel_hh_hp = null;
        this.deactivateField('exist_wel_hp');
        values.exist_wel_hp = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_hp')) {
      if (values.exist_wel_hp === 'ja') {
        this.activateField('wel_hp');
        this.activateField('exist_wel_hp_date');
      } else {
        this.deactivateField('wel_hp');
        this.deactivateField('exist_wel_hp_date');
        values.wel_hp = null;
        values.exist_wel_hp_date = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_hp_date')) {
      if (values.exist_wel_hp_date === 'ja') {
        this.activateField('date_hp');
      }
      else {
        this.deactivateField('date_hp');
        values.date_hp = null;
      }
    }
    return values;
  }

  private updateFieldsHeating(values: { [key: string]: any }): { [key: string]: any } {
    if (values.hasOwnProperty('exist_hp')) {
      if (values.exist_hp === 'ja') {
        this.deactivateField('exist_eheat');
        values.exist_eheat = null;
      } else {
        this.activateField('exist_eheat');
      }
    }
    if (values.hasOwnProperty('exist_eheat')) {
      if (values.exist_eheat === 'ja') {
        this.activateField('include_wel_hh_eheat');
      } else {
        this.deactivateField('include_wel_hh_eheat');
        values.include_wel_hh_eheat = null;
      }
    }
    if (values.hasOwnProperty('include_wel_hh_eheat')) {
      if (values.include_wel_hh_eheat === 'ja') {
        this.activateField('exist_wel_eheat');
      } else {
        this.deactivateField('exist_wel_eheat');
        values.exist_wel_eheat = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_eheat')) {
      if (values.exist_wel_eheat === 'ja') {
        this.activateField('wel_eheat');
        this.activateField('exist_wel_eheat_date');
      } else {
        this.deactivateField('exist_wel_eheat_date');
        values.exist_wel_eheat_date = null;
        this.deactivateField('wel_eheat');
        values.wel_eheat = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_eheat_date')) {
      if (values.exist_wel_eheat_date === 'ja') {
        this.activateField('date_ehheat');
      } else {
        this.deactivateField('date_ehheat');
        values.date_ehheat = null;
      }
    }
    return values;
  }

  private updateFieldsWarmwater(values: { [key: string]: any }): { [key: string]: any } {
    if (values.hasOwnProperty('exist_hp')) {
      if (values.exist_hp === 'ja') {
        this.setOptions('type_dhw', ['ohne_strom', 'direktelektrisch', 'waermepumpe']);
      } else {
        if (values.hasOwnProperty('type_dhw') && values.type_dhw === 'waermepumpe') {
          values.type_dhw = null;
        }
        this.setOptions('type_dhw', ['ohne_strom', 'direktelektrisch', 'beides']);
      }
    }
    return values;
  }

  private updateFieldsPhotovoltaic(values: { [key: string]: any }): { [key: string]: any } {
    if (values.hasOwnProperty('exist_pv')) {
      if (values.exist_pv === 'ja') {
        this.activateField('exist_wel_pv');
      } else {
        this.deactivateField('exist_wel_pv');
        values.exist_wel_pv = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_pv')) {
      if (values.exist_wel_pv === 'ja') {
        this.activateField('wel_pv');
        this.activateField('exist_wel_pv_date');
        this.deactivateField('p_pv_peak');
        values.p_pv_peak = null;
        this.deactivateField('exist_battery_pv');
        values.exist_battery_pv = null;
      } else if (values.exist_wel_pv === 'nein') {
        this.deactivateField('wel_pv');
        values.wel_pv = null;
        this.deactivateField('exist_wel_pv_date');
        values.exist_wel_pv_date = null;
        this.activateField('p_pv_peak');
        this.activateField('exist_battery_pv');
      } else {
        this.deactivateField('p_pv_peak');
        values.p_pv_peak = null;
        this.deactivateField('exist_battery_pv');
        values.exist_battery_pv = null;
        this.deactivateField('wel_pv');
        values.wel_pv = null;
        this.deactivateField('exist_wel_pv_date');
        values.exist_wel_pv_date = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_pv_date')) {
      if (values.exist_wel_pv_date === 'ja') {
        this.activateField('date_pv');
      } else {
        this.deactivateField('date_pv');
        values.date_pv = null;
      }
    }
    if (values.hasOwnProperty('exist_battery_pv')) {
      if (values.exist_battery_pv === 'ja') {
        this.activateField('wel_battery_pv');
      } else {
        this.deactivateField('wel_battery_pv');
        values.wel_battery_pv = null;
      }
    }
    return values;
  }

  private updateFieldsElectricVehicle(values: { [key: string]: any }): { [key: string]: any } {
    if (values.hasOwnProperty('exist_ev')) {
      if (values.exist_ev === 'ja') {
        this.activateField('wel_ev_grid');
      } else {
        this.deactivateField('wel_ev_grid');
        values.wel_ev_grid = null;
      }
    }
    if (values.hasOwnProperty('wel_ev_grid')) {
      if (values.wel_ev_grid === 'ja') {
        this.activateField('wel_ev');
        this.activateField('exist_wel_ev');
      } else {
        this.deactivateField('exist_wel_ev');
        values.exist_wel_ev = null;
        this.deactivateField('wel_ev');
        values.wel_ev = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_ev')) {
      if (values.exist_wel_ev === 'ja') {
        this.activateField('wel_ev');
        this.activateField('exist_wel_ev_date');
        this.deactivateField('distance_ev');
        values.distance_ev = null;
        this.deactivateField('f_ev_percentage');
        values.f_ev_load = null;
      } else if (values.exist_wel_ev === 'nein') {
        this.deactivateField('wel_ev');
        values.wel_ev = null;
        this.deactivateField('exist_wel_ev_date');
        values.exist_wel_ev_date = null;
        this.activateField('distance_ev');
        this.activateField('f_ev_percentage');
      } else {
        this.deactivateField('distance_ev');
        values.distance_ev = null;
        this.deactivateField('f_ev_percentage');
        values.f_ev_load = null;
        this.deactivateField('wel_ev');
        values.wel_ev = null;
        this.deactivateField('exist_wel_ev_date');
        values.exist_wel_ev_date = null;
      }
    }
    if (values.hasOwnProperty('exist_wel_ev_date')) {
      if (values.exist_wel_ev_date === 'ja') {
        this.activateField('date_ev');
      } else {
        this.deactivateField('date_ev');
        values.date_ev = null;
      }
    }
    return values;
  }
}
